function Loader() {
  return (
    <div className="flex justify-center py-4">
      <div className="w-10 h-10 border-4 border-blue-400 border-t-transparent rounded-full animate-spinSlow"></div>
    </div>
  );
}

export default Loader;
